module.exports = __webpack_public_path__ + "img/2.0b1386ea.jpg";